import React from 'react';
import CommingSoon from "../../images/coming-soon.png";
import { Container } from '@material-ui/core';
import "./Request.css";

// Main component for the Commingsoon page
export default function Request() {
  return (
    <>
      {/* Container for displaying the "Coming Soon" image */}
      <Container className="request-container">
        <img src={CommingSoon} alt="Coming Soon" />
      </Container>
    </>
  );
}

